module.exports = __webpack_public_path__ + "img/expression.9b3b0faf.svg";